import { AppType } from "@azm/core/enums/app-types";
import { EnvironmentMode } from "@azm/core/enums/environment-mode";
import { createEnvironment } from "./environment.shared";

export const environment = createEnvironment({
	production: false,
	mode: EnvironmentMode.Dev,
	appType: AppType.Internal,
	apiBaseUrl: "https://localhost:7214/",
	enableThemeSwitch: false,
	enableAccessibilityTools: true,
	useMockApi: false,
});
